import { render, staticRenderFns } from "./AllPrograms.vue?vue&type=template&id=5aa83378"
import script from "./AllPrograms.vue?vue&type=script&lang=ts"
export * from "./AllPrograms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports